export default __webpack_public_path__ + "static/media/bank1.38a15a99.jpg";